 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		37: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		37: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","3":"vendors~GDPRPrompt~PlaylistPage~PlaylistWrapped~teamChat~teamFans~teamGames~teamGmTools~teamMain~tea~95c5a89d","6":"vendors~FrontPage~PlaylistPage~teamGmTools~teamScores~teamSquads","8":"vendors~GamePage~PlaylistWrapped~TeamPage~scheduleWidget","9":"GDPRPrompt","10":"vendors~GamePage~TeamPage~userHeader","11":"GamePage-Details~ssUiGameVenue","12":"vendors~UserWidgetsPage~ssUiPremiumWidgetSubscriptions","13":"vendors~teamNoMatch~userHandOfGodInspector","14":"vendors~userHandOfGodInspector~userHeader","16":"EmbedHeader","17":"FrontPage","18":"GamePage","19":"GamePage-Chat","20":"GamePage-Details","21":"GamePage-Fans","22":"GamePostPage","23":"HandOfGod","24":"HeaderFrontPage","25":"Internal-NotificationsPage","26":"Internal-SystemMetricsPage","27":"InternalPage","28":"NoMatchPage","29":"NotificationsPage","30":"PlaylistPage","31":"PlaylistWrapped","32":"TeamPage","33":"UpdateGameModal","34":"UserPage","35":"UserWidgetsPage","36":"WidgetCreatorsPage","38":"cachedLevelsOfPlay","39":"logosAndSponsors","40":"scheduleWidget","41":"ssTeamScheduleWidget","42":"ssUiGameVenue","43":"ssUiPremiumWidgetSubscriptions","44":"ssUiTeamOverrideManager","45":"ssUiTeamScheduleWidget","46":"ssUiTeamVenueManager","47":"ssUiTrendingList","48":"ssUiVenueTypeToFind","49":"teamChat","50":"teamFans","51":"teamGames","52":"teamGmTools","53":"teamMain","54":"teamMedia","55":"teamNoMatch","56":"teamScheduleCreator","57":"teamScheduleCreatorForm","58":"teamScores","59":"teamSquads","60":"userEdit","61":"userEditCommunicationSettings","62":"userFollowers","63":"userFollowing","64":"userHandOfGodInspector","65":"userHeader","66":"userMedia","67":"userPage","68":"userTeams","69":"vendors~GamePage","70":"vendors~GamePage-Fans","71":"vendors~Internal-SystemMetricsPage","72":"vendors~NotificationsPage","73":"vendors~UserWidgetsPage","74":"vendors~scheduleWidget","75":"vendors~userEditCommunicationSettings","76":"vendors~userHandOfGodInspector","77":"vendors~userMedia"}[chunkId]||chunkId) + "." + {"0":"1115b23c4fee6de7b8e7","1":"cdc8cc9080f023ad335d","2":"0cb7a64a47ffe4b46b60","3":"446e8ed8b5a9faaa2200","4":"a140a8ce9f50a3c48055","5":"c1550197a060b3ee705a","6":"fc02b3811bca2a220f55","7":"40e676759a8217ee7c96","8":"1d5c8ba7a1e3b1892b93","9":"e9d1cf82218db66b228b","10":"f770603f7c7bea6fcefd","11":"a8177c20c08cfa563242","12":"9de8bf600d175d0f282c","13":"01002103be8a0929ced7","14":"fd710b241e392dc4b304","15":"1063d7d18876d2bd328c","16":"7559f768d0166dbba83a","17":"b90212caed12be76b0af","18":"261e4c5749302f3c3277","19":"95e2dd1b3b1f43752b96","20":"cba815321bf139c5d8d5","21":"3d4e9483d46c76868f37","22":"f565cbd75e6efae94390","23":"c5c846a822d4c02cbcc4","24":"eb91a3c978998815fe83","25":"605ee0254d66ae14f4d2","26":"6aeaf5e629f6305e3a7c","27":"dd20a8ccb108e37a0a75","28":"7894b8f13ac3ef21b34f","29":"02af05c398274a6e1371","30":"a022ec21e715bba4c67d","31":"e5152d3bc1fc25f41a56","32":"00e539d721356094b4b8","33":"d3e071e23e2c5909e6a8","34":"7b392136494348622d3c","35":"05a2476a8473de09d583","36":"5ea1302f473faaff57e0","38":"42601348daf83835ee4f","39":"b582a626eb98bb383a24","40":"adfc0572c7cc65c6ba83","41":"31487f482c31439c3da9","42":"5b6608a9b2e004aca178","43":"16c3c99da008c699b1b2","44":"a0d2a7d15f70cadf0a7b","45":"a75d1c30f645b68d55cb","46":"83db43602de56cfd2c9b","47":"a9e9b8cd1eaa4dd634ac","48":"e711f9c0900bb54155ee","49":"52e8e0a81ce1331c8097","50":"37850d786da8be8b58e0","51":"14fd1eb1e11404ed2ad6","52":"2f67eae6427f21be4f6b","53":"c837b5c8ac68c32b020a","54":"4e022fc632f611ec9f09","55":"cb91366209dd19a38a22","56":"ab66ac24f497b07fe38e","57":"a187b45fe70afd6a3027","58":"fc88edf4b5d4cfac0683","59":"def60626e5913d086663","60":"133b5b30241257c94418","61":"4fec5f4bed343b9ea966","62":"4ff82a643b4d7de66cc9","63":"4ae48b4678154fb76465","64":"99b142bbdbd632a806bf","65":"d2bfff1c85cd027915c8","66":"198aa645ba22a3a7ab4c","67":"ab3b77871d4d27ff719b","68":"c99fa4df17606c8ad97e","69":"91d96dc467279a3f4146","70":"d2897490a38122a14909","71":"b42eac08830ca61da0d3","72":"1974deaae8d514134141","73":"146f24fff398ab3b2ebb","74":"da412e8d4dd6a823e8ce","75":"87b577570e9c45cf3c6f","76":"cea41d112d2998380e88","77":"4d1729248d22f9967161","78":"40f49546457c39115196","79":"d3a843b2ca245fbca91d","80":"e2b662d6fbbb81ba4040","81":"7ee334d52723ce3212dd","82":"15d4dcd4189ef53654c6","83":"fb70a4cdd93418a5e471","84":"39cf049dd2500d4e2d87","85":"c9eff55ebb51b784526f","86":"aaeb2655cfd4f1433b1b","87":"47bc9cccddd2ccdc1371","88":"45f951f44d88589461fe","89":"68b73436b81b05935053"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + chunkId + ".extractedFromBundle." + "44bf907b998afa47169f" + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "realtime/app";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["ssuiWebpackJsonp"] = window["ssuiWebpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 874);
